/*
 * @Description: 路由
 * @Date: 2025-07-25 10:31:12
 */
export const route = [
  {
    path: '/acceptance-report-list',
    name: 'acceptance-report-list',
    meta: {
      title: '终端履约验收报告'
    },
    component: () => import('../views/acceptance-report-list.vue')
  },
  {
    path: '/acceptance-report-record',
    name: 'acceptance-report-record',
    meta: {
      title: '生成记录',
      parentPath: '/acceptance-report-list'
    },
    component: () => import('../views/acceptance-report-record.vue')
  }
];
